module.exports = __webpack_public_path__ + "static/media/12learn-logo.397d94a9.png";